import { render, staticRenderFns } from "./CartPositionItem.vue?vue&type=template&id=3008053e&scoped=true"
import script from "./CartPositionItem.vue?vue&type=script&lang=ts"
export * from "./CartPositionItem.vue?vue&type=script&lang=ts"
import style0 from "./CartPositionItem.vue?vue&type=style&index=0&id=3008053e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3008053e",
  null
  
)

export default component.exports